import styled from 'styled-components';

import { colors } from 'config/theme';

export const Banner = styled.div`
  font-size: 0.87rem;
  line-height: 1.5;
  background-color: #f0f0f0;
  font-family: Source Sans, sans-serif;
`;
export const BannerHeader = styled.header`
  color: #1b1b1b;
  position: relative;
`;
export const BannerHeaderInner = styled.div`
  font-weight: 500;
  font-size: 12.5px;
  margin-left: auto;
  max-width: none;
  margin-right: auto;
  padding-left: 1rem;
  display: flex;
  flex-direction: row;
  padding-right: 0;
  align-items: baseline;
`;
export const BannerHeaderIcon = styled.div`
  margin-right: 7px;
  padding: 0.25rem 0rem;
`;
export const BannerHeaderContent = styled.div`
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
  padding: 0.25rem 0rem;
`;
export const BannerHeaderContentText = styled.span`
  margin-right: 7px;
`;
export const BannerHeaderHiddenContent = styled.div`
  display: none;
  color: #005ea2;
  margin-bottom: 0;
  margin-top: 0;
  text-decoration: underline;

  @media screen and (max-width: 700px) {
    display: block;
  }
  svg {
    display: inline-block;
    vertical-align: middle;
  }
`;

export const BannerHeaderButton = styled.button`
  color: #005ea2;
  text-decoration: underline;
  text-decoration: underline;
  background-color: transparent;
  border: 0;
  padding: 0;
  text-align: left;
  cursor: pointer;
  font-family: Source Sans, sans-serif;
  font-weight: 500;
  font-size: 12.5px;
  outline: 0;

  @media screen and (max-width: 700px) {
    width: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
    span {
      position: absolute;
      left: -999em;
    }
  }
  svg {
    display: inline-block;
    vertical-align: middle;
  }
`;

export const BannerContent = styled.div`
  background-color: transparent;
  font-size: 1rem;
  overflow: hidden;
  width: 100%;
  display: flex;
  padding: 24px 8px;
  justify-content: center;
  @media screen and (max-width: 700px) {
    justify-content: left;
    flex-wrap: wrap;
    padding: 4px 16px 16px 8px;
  }
`;

export const BannerContentCol = styled.div`
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0;
  display: flex;
  flex: 0 1 auto;
  max-width: 60ex;
  min-width: 30ex;
  align-items: flex-start;
  box-sizing: border-box;
  @media screen and (max-width: 700px) {
    padding: 24px 8px 0px;
  }
  div {
    flex: 1 1;
  }
  img {
    flex-shrink: 0;
    width: 40px;
    margin-right: 10px;
  }
  strong {
    font-weight: 700;
  }
  p {
    margin-top: 0px;
    margin-bottom: 0px;
    font-weight: 500;
  }
`;
export const ExitButton = styled.div<{ visible: boolean }>`
  right: 0px;
  display: none;
  background: ${colors.lightGray};
  svg {
    fill: ${colors.darkBlue};
    width: 25px;
    height: 25px;
  }
  @media screen and (max-width: 700px) {
    display: ${(props) => (props.visible ? 'flex' : 'none')};
    width: 40px;
    height: 40px;
    align-items: center;
    justify-content: center;
  }
`;
